/**
 * Choose rows × cols = parts so each grid cell is as square as possible.
 * Square cells: imageWidth/cols === imageHeight/rows  →  cols/rows === aspectRatio
 */
export function computePuzzleGrid(parts, imageAspectRatio = 4 / 3) {
  const n = Math.max(2, Math.min(100, Math.floor(Number(parts)) || 9));
  const ar = Number(imageAspectRatio) > 0 ? Number(imageAspectRatio) : 4 / 3;

  let has2dGrid = false;
  for (let r = 2; r <= Math.floor(n / 2); r += 1) {
    if (n % r === 0) {
      has2dGrid = true;
      break;
    }
  }

  let bestRows = 1;
  let bestCols = n;
  let bestScore = Infinity;

  for (let rows = 1; rows <= n; rows += 1) {
    if (n % rows !== 0) continue;
    const cols = n / rows;

    // Never split into a single row or single column when a 2D grid exists
    if (n >= 4 && has2dGrid && (rows === 1 || cols === 1)) {
      continue;
    }

    const cellAspect = ar * (rows / cols);
    const score = Math.abs(Math.log(cellAspect));

    if (score < bestScore) {
      bestScore = score;
      bestRows = rows;
      bestCols = cols;
    }
  }

  return { parts: n, rows: bestRows, cols: bestCols };
}

/** True when grid cells are (nearly) square for the given image aspect ratio. */
export function areCellsSquare(rows, cols, imageAspectRatio) {
  const ar = Number(imageAspectRatio) > 0 ? Number(imageAspectRatio) : 4 / 3;
  const cellAspect = ar * (rows / cols);
  return Math.abs(cellAspect - 1) < 0.15;
}
